import post from '../../../RestAPI/fetchData';
import get from '../../../RestAPI/getDataService';
import config from '../../../config/App_data';
const session = JSON.parse(localStorage.getItem('localstorageval')) || {};
const { token, idname } = session;
const payload = {
  token,
  idname,
};
const getQuizDetails = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_quizes/getQuize`, {
    ...payload,
    ...data,
  });
};

const getQuestionById = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_quizes/getQuestionsbyid`, {
    ...payload,
    ...data,
  });
};

const checkUserSelectedAnswer = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_quizes/checkAnswered`, {
    ...payload,
    ...data,
  });
};
const insertUserTimer = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_quizes/insertTimer`, {
    ...payload,
    ...data,
  });
};
const saveQuizAnswer = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_quizes/answerQuiz`, {
    ...payload,
    ...data,
  });
};
const saveAttemptStats = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/saveStats`, {
    ...payload,
    ...data,
  });
};

const fetchSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/getFavQuestions`, {
    ...payload,
    ...data,
  });
};
const saveQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/saveQuestion`, {
    ...payload,
    ...data,
  });
};
const deleteSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/unsaveQuestion`, {
    ...payload,
    ...data,
  });
};

const saveReport = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/reportQuestion`, {
    ...payload,
    ...data,
  });
};
const saveRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/saveEARatting`, {
    ...payload,
    ...data,
  });
};

const fetchRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/getEARatting`, {
    ...payload,
    ...data,
  });
};

const updateQuestionRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/ea_question_bank/UpdateEARatting`, {
    ...payload,
    ...data,
  });
};

export const apiServices = {
  saveAttemptStats,
  saveQuizAnswer,
  getQuestionById,
  getQuizDetails,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  saveReport,
  saveRating,
  fetchRating,
  updateQuestionRating,
  checkUserSelectedAnswer,
  insertUserTimer,
};



// WEBPACK FOOTER //
// ./src/views/EA-Exams/Quizzes/BeginQuiz/ApiServiceProvider.js